<script setup lang="ts">
import { TEXT } from '../../configs/text';
import { useAuthStore, useClassStore, useUserStore } from '../../stores';

import { useI18n } from 'petite-vue-i18n';
import { computed } from 'vue';
import { UserRole } from '../../types/user';
import { ClassStatus } from '../../types/class';
import RequestJoinClassList from './RequestJoinClassList.vue';
import EndClass from './EndClass.vue';
import Settings from './Settings.vue';
import ViewMode from './ViewMode.vue';
import StudentLeaderboard from './StudentLeaderboard.vue';
import logoSrc from '../../assets/imgs/iclass-logo.svg';
import ChangeLanguage from './ChangeLanguage.vue';

const auth = useAuthStore()
const user = useUserStore()
const classStore = useClassStore()

const hasRequest = computed(() => {
    return user.userRole === UserRole.teacher && classStore.requestedStudentIds.length && classStore.selectedClassDetails
})

const { t } = useI18n()
</script>

<template>
    <div class="flex flex-wrap items-center gap-2 py-3 px-3 md:px-8 bg-white">
        <img :src="logoSrc" class="w-24 mr-6" />
        <template v-if="auth.isAuthenticated">
            <div>
                <div class="text-sm">{{ t(TEXT.hello) }}{{ user.userRoleName && ', ' + t(user.userRoleName) }}!
                </div>
                <div class="text-xl font-bold"> {{ user.userInfo?.full_name }} </div>
            </div>
            <div class="flex items-center justify-center grow">
                <template v-if="classStore.selectedClassDetails && user.userRole === UserRole.teacher">
                    <ViewMode />
                </template>
                <div v-if="classStore.selectedClassDetails?.student_group_id && classStore.selectedClassDetails?.state === ClassStatus.on_going && user.userRole === UserRole.student"
                    class="bg-neutral-100 rounded-lg text-center py-2 px-5">
                    <div class="font-bold text-2xl text-lime-500">
                        {{ classStore.getClassGroupNameById(classStore.selectedClassDetails.student_group_id) }}
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap items-center gap-2 mx-auto">
                <div v-if="classStore.selectedClassDetails?.access_code && user.userRole === UserRole.teacher"
                    class="bg-neutral-100 rounded-lg text-center py-2 px-3">
                    <div class="font-bold text-2xl text-lime-500">
                        {{ classStore.selectedClassDetails.access_code }}
                    </div>
                </div>
                <RequestJoinClassList v-if="hasRequest" />
                <EndClass
                    v-if="classStore.selectedClassDetails?.state === ClassStatus.on_going && user.userRole === UserRole.teacher" />
                <StudentLeaderboard
                    v-if="classStore.selectedClassDetails?.state === ClassStatus.on_going && user.userRole === UserRole.student" />
                <Settings />
            </div>
        </template>
        <ChangeLanguage v-else class="ml-auto" />
    </div>
</template>